import * as React from 'react';
import {useSelector} from 'react-redux';

import {Session} from 'nutshell-core/session';

import {DynamicStatusButton} from 'shells/button/dynamic-status-button/dynamic-status-button';
import {LoadingText} from 'shells/loading-placeholder/loading-text';

import {useGetAnalyticsStatus} from '../../use-get-analytics-status';

import {getFlashBannerType, getStatusDescription} from './helpers';
import {StatusBody} from './status-body';
import type {PageType} from './types';

type Props = {
    pageType: PageType;
    includeSeeAll?: boolean;
};

export function AnalyticsStatusButton(props: Props) {
    // @ts-expect-error
    const loggedInUser = useSelector((state) => Session.getSessionStateUser(state));
    const canAccessSetup = loggedInUser && loggedInUser.permissions.canAccessSetup;

    const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);

    const {analyticsStatus, isLoading} = useGetAnalyticsStatus();

    const {status, chatStatus, numActiveForms, numInactiveForms, snippetVersion} =
        analyticsStatus || {};

    if (!canAccessSetup) {
        return null;
    }

    const statusToUse = props.pageType === 'chat' ? chatStatus : status;

    return (
        <>
            {isLoading || !analyticsStatus ? (
                <LoadingText height={31} width={150} />
            ) : (
                <DynamicStatusButton
                    text={props.pageType === 'chat' ? 'Chat snippet' : 'Tracking snippet'}
                    // @ts-expect-error
                    headerType={getFlashBannerType(statusToUse)}
                    // @ts-expect-error
                    headerContent={getStatusDescription(statusToUse)}
                    isDialogOpen={isDialogOpen}
                    setIsDialogOpen={setIsDialogOpen}
                    popoverContent={
                        <StatusBody
                            // @ts-expect-error
                            status={statusToUse}
                            // @ts-expect-error
                            snippetVersion={snippetVersion}
                            // @ts-expect-error
                            numActiveForms={numActiveForms}
                            // @ts-expect-error
                            numDraftForms={numInactiveForms}
                            onClosePopover={() => setIsDialogOpen(false)}
                            includeSeeAll={props.includeSeeAll}
                            pageType={props.pageType}
                        />
                    }
                />
            )}
        </>
    );
}
